import { useEffect } from "react";

/**
 * Patch 24 · safety net: Radix dialogs / vaul drawers set `pointer-events: none` on <body> while open.
 * If two of them close at the same moment one can leave it behind and nothing on the page is clickable.
 * Whenever no dialog or drawer is open any more, give the page its clicks back.
 */
export default function BodyUnlock() {
  useEffect(() => {
    let t = 0;
    const check = () => {
      clearTimeout(t);
      t = setTimeout(() => {
        const b = document.body;
        if (b.style.pointerEvents !== "none") return;
        const open = document.querySelector('[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"], [data-vaul-drawer][data-state="open"]');
        if (!open) b.style.pointerEvents = "";
      }, 350);
    };
    const mo = new MutationObserver(check);
    mo.observe(document.body, { attributes: true, attributeFilter: ["style"], childList: true });
    return () => {
      clearTimeout(t);
      mo.disconnect();
    };
  }, []);
  return null;
}
